export enum InputTypes {
  TEXT = 'text',
  NUMERIC = 'numeric',
  COMMENTS = 'comments',
  LIST_TEST = 'listText',
  LIST_NUMERIC = 'listNumeric',
  VALUES_LIST_SINGLE = 'valuesListSingle',
  VALUES_LIST_MULTIPLE = 'valuesListMultiple'
}
